export default __webpack_public_path__ + "static/logo-white-50616b2006bac6411b7162e5ac961514.svg";